import { render, staticRenderFns } from "./home.vue?vue&type=template&id=60239910&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=60239910&prod&lang=scss&scoped=true"
import style1 from "./home.vue?vue&type=style&index=1&id=60239910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60239910",
  null
  
)

export default component.exports